import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'gatsby-link';

function Podcastlisting(props) {
    return (
        <div className="podcast_listing tekrevol_gray_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="mb-5">
                        <div className="example" data-text="Podcast Ep">
                            <h2>Latest Episodes</h2>
                        </div>
                        <p>
                            We collaborate with entrepreneurs and industry leaders to emphasize the importance of digital
                            transformation. We regularly invite technopreneurs and change leaders to talk about how technology
                            played a crucial role in transforming their businesses and how it helps them scale up with sustainability.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>Featuring Rajat Mishra Co-Founder of Prezentium</h4>
                            <div className="podcast_txt">
                                <p>S02 E06 of Technology For Change - featuring Co-Founder of Prezentium, Rajat Mishra as we talk about....</p>
                            </div>
                            <Link to="/podcast/technology-for-change-season2-ep6" className="btn_podcast">
                                Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>An Angel Investor the Founder of Uniqorn Incubator and Startup Super Cup</h4>
                            <div className="podcast_txt">
                                <p>On S02 E05, we've invited Dom Einhorn, the Founder of Uniqorn Incubator and Startup Super Cup.On S02 E05, we've invited Dom Einhorn, the Founder of Uniqorn Incubator and Startup Super Cup...</p>
                            </div>
                            <Link to="/podcast/technology-for-change-season2-ep5" className="btn_podcast">
                                Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>Tim Kalinowski, Founder, and CEO of LORE</h4>
                            <div className="podcast_txt">
                                <p>Helping your business/product transform into a brand through communication, Tekrevol partners with Tim Kalinowski, Founder, and CEO of LORE....</p>
                            </div>
                            <Link to="/podcast/technology-for-change-season2-ep4" className="btn_podcast">
                                Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Podcastlisting;
